import script from "./ProductOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductOrder.vue?vue&type=script&setup=true&lang=js"

import "./ProductOrder.vue?vue&type=style&index=0&id=28aa14ae&lang=scss&scoped=true"

import exportComponent from "F:\\ubuntuBK\\sombardc\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28aa14ae"]])

export default __exports__